import { FC } from 'react';
import { ExamQuestionsModal } from './ExamQuestion/ExamQuestionModal';
import { ExamLoadingModal } from './ExamLoading/ExamLoadingModal';
import { ExamResultModal } from './ExamResultModal/ExamResultModal';

export const ExamModal: FC = () => {
  return (
    <>
      <ExamQuestionsModal />
      <ExamLoadingModal />
      <ExamResultModal />
    </>
  );
};
